import { ThemeProvider } from "@mui/material";

import "./App.scss";
import { Routes } from "./storage/routes";
import { BottomBar, TopBar } from "./Components/Bars";
import muiTheme from "./storage/muiTheme";
import { DemoModal } from "./Components/Modals";
import React, { useCallback, useEffect, useState } from "react";
import Emitter, {
  DISPLAY_MODAL,
  displayUI,
  HIDE_MODAL,
  hideUI,
} from "./storage/emitter";
import { AnimatePresence } from "framer-motion";
import { useUIShown } from "./storage/hooks";
import { dnsnetApi } from "./services/apis";
import { useLocation } from "react-router-dom";
import appProperties from "./storage/app-properties";

let mouseMoveTO;

function App() {
  const isUIShown = useUIShown();
  const { pathname } = useLocation();
  const [demoModal, setDemoModal] = useState(undefined);
  const [modalCloseType, setModalCloseType] = useState(undefined);

  const setModal = (modalType, value) => {
    if (modalType === "all" || modalType === "demo") {
      setDemoModal(value);
    }
  };

  const purtvPing = useCallback(() => {
    dnsnetApi.ping();
  }, []);

  useEffect(() => {
    Emitter.on(DISPLAY_MODAL, ({ modalType, closeType }) => {
      setModal(modalType, true);
      setModalCloseType(closeType);
    });
    Emitter.on(HIDE_MODAL, (modalType) => {
      setModal(modalType, false);
      setModalCloseType(undefined);
    });
    dnsnetApi.getEpg();
    purtvPing();
    let purtvPingInterval = setInterval(() => {
      purtvPing();
    }, 15000);
    return () => {
      Emitter.off(DISPLAY_MODAL);
      Emitter.off(HIDE_MODAL);
      clearInterval(purtvPingInterval);
    };
  }, []);

  const onUserActive = useCallback((event) => {
    displayUI();
  }, []);
  const onUserInactive = useCallback(
    (event) => {
      if (pathname.includes("/live/")) {
        setTimeout(() => {
          hideUI();
        }, 5e3);
      }
    },
    [pathname]
  );
  const onMouseMove = useCallback(() => {
    clearTimeout(mouseMoveTO);
    displayUI();
    if (pathname.includes("/live/") || pathname.includes("/player/")) {
      mouseMoveTO = setTimeout(() => {
        hideUI();
      }, 10e3);
    }
  }, [pathname]);

  return (
    <div
      className={"App" + (appProperties.ltd ? " App-ltd" : "")}
      onMouseEnter={onUserActive}
      onMouseLeave={onUserInactive}
      onMouseMove={onMouseMove}
      onMouseDown={onUserActive}
    >
      <ThemeProvider theme={muiTheme}>
        <Routes />
        <AnimatePresence
          initial={false}
          exitBeforeEnter={false}
          onExitComplete={() => null}
        >
          {!appProperties.ltd && isUIShown && <TopBar key="top-bar" />}
          {!appProperties.ltd && isUIShown && <BottomBar key="bottom-bar" />}
          {demoModal && (
            <DemoModal key="demo-modal" closeType={modalCloseType} />
          )}
        </AnimatePresence>
      </ThemeProvider>
    </div>
  );
}

export default App;
